import { render } from "./NewsDetail.vue?vue&type=template&id=3f525658&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"

import "./NewsDetail.vue?vue&type=style&index=0&id=3f525658&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f525658"

export default script